<template>
  <img class="serial" :src="src" alt="">
</template>

<script>
export default {
  name: 'serial',
  props: {
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    src() {
      const obj = {
        1: require('./img/one.png'),
        2: require('./img/two.png'),
        3: require('./img/three.png')
      }
      return obj[this.index]
    }
  }
}
</script>

<style lang="less" scoped>
.serial {
  width: 22px;
  height: 22px;
}
</style>
